import React from "react";
import DynamicLayout from "../components/DynamicLayout";
import PlanetaryHoursExperience from "../components/tools/PlanetaryHoursExperience";
import '../assets/ascendant-display.sass';

const PlanetaryHoursPage = () => {
    return (
        <DynamicLayout>
            <PlanetaryHoursExperience />
        </DynamicLayout>
    );
};

export default PlanetaryHoursPage; 
